module.exports = __webpack_public_path__ + "static/ec-baseline-desktop-51dd8c5cebff795a2a491d982f60c7bd.png";